import { Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLivyAccess } from 'src/components/livy/access';
import { helpLivy } from 'src/components/livy/LivyGreeting';
import useStyles from './styles';
export const HELP_CENTER_URL = 'https://pro.livable.com/knowledge';

/**
 * Opens help for a topic: Livy's Help tab when Livy is on for the company, else the public knowledge base
 * (`fallbackUrl`, for a page that links one specific article).
 */
export function useOpenHelp() {
  const livy = useLivyAccess();
  return function (topic) {
    let fallbackUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HELP_CENTER_URL;
    return livy ? helpLivy(topic) : window.open(fallbackUrl, '_blank');
  };
}
/**
 * Help for the control it sits beside. With Livy on for the company it opens Livy's Help tab already searching the
 * topic, so there is no separate help center to search; without Livy it falls back to the public knowledge base.
 */
export default function HelpCenterButton(_ref) {
  let _ref$topic = _ref.topic,
    topic = _ref$topic === void 0 ? '' : _ref$topic;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const openHelp = useOpenHelp();
  return /*#__PURE__*/React.createElement(Button, {
    className: classes.helpCenterButton,
    onClick: () => openHelp(topic),
    variant: "actionButton",
    'custom-attribute': '335-HelpCenterButton'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.more_details_at_help_center')));
}